import { createState, useState } from '@hookstate/core';

interface ViewContractsState {
  editMode: boolean;
  diffingMode: boolean;
  diffingContract: string | undefined;
  approveDialog: boolean;
  requestDialog: boolean;
  rejectDialog: boolean;
  cancelDialog: boolean;
  comments: string;
}

const initialState: ViewContractsState = {
  editMode: false,
  diffingMode: false,
  diffingContract: undefined,
  comments: '',
  approveDialog: false,
  requestDialog: false,
  rejectDialog: false,
  cancelDialog: false,
};

const viewContractsState = createState(initialState);

export function useViewContractsState() {
  return useState(viewContractsState);
}
